"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const baseURL = "https://api.tidal.com/v1/search";
const searchFactory = (url, axios) => async ({ query, limit = 50, countryCode = "US", client_id, access_token, }) => {
    let headers = { "x-tidal-token": client_id };
    if (!client_id)
        headers = { authorization: `Bearer ${access_token}` };
    if (!client_id && !access_token)
        throw new Error("You need to either provide a client_id or an access_token.");
    const { data } = await axios({
        baseURL,
        headers,
        url,
        params: {
            countryCode,
            query,
            limit,
        },
        responseType: "json",
    });
    return data;
};
exports.default = (axios) => ({
    all: searchFactory("", axios),
    artists: searchFactory("artists", axios),
    albums: searchFactory("albums", axios),
    tracks: searchFactory("tracks", axios),
    videos: searchFactory("videos", axios),
    playlists: searchFactory("playlists", axios),
});
